import styled from '@emotion/styled'

const CUSTOM_SCROLLBAR = {
	scrollbarCustomVertical: `
		padding-right: 0.6em;
		&::-webkit-scrollbar {
			width: 0.3em;
		}
		&::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
			border-radius: 100px;
		}
		&::-webkit-scrollbar-thumb {
			background-color: rgba(128,128,128,0.5);
			border-radius: 100px;
		}
	`,

	scrollbarCustomHorizontal: `
		padding-bottom: 0.6em;
		&::-webkit-scrollbar {
			height: 0.3em;
		}
		&::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
			border-radius: 100px;
		}
		&::-webkit-scrollbar-thumb {
			background-color: rgba(128,128,128,0.5);
			border-radius: 100px;
		}
	`,
}

const BackdropModal = styled('div')`
	z-index: -1;
	position: fixed;
	background-color: ${({ theme }) =>
		`${theme.palette.modalColors.backgroundColor};`}

	width: 80%;
	max-width: 1200px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	border: 1px solid #393939;
	box-sizing: border-box;
	border-radius: 8px;
	padding: 20px;
	max-height: 95%;
	overflow: auto;
	-ms-overflow-style: none;
	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: 'none';
	}
`

const SKIP_DOLLAR_PROPS = {
	shouldForwardProp: (prop: string) => !prop.startsWith('$'),
}

export { BackdropModal, CUSTOM_SCROLLBAR, SKIP_DOLLAR_PROPS }
